import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  OnChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LayoutService } from '../../../services/layout.service';

@Component({
  selector: 'col-632',
  templateUrl: './col-632.component.html',
  styleUrls: ['./col-632.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class Col632Component implements OnChanges {
  @Input() index: any;
  @Input() templates: any;
  @Input() footer: any;
  @Input() edit: boolean;
  @Output() component = new EventEmitter<any>();
  matchmedia_height: number;
  matchmedia_width: number;
  componentData: any = [];

  Footer = [
    {
      typeOf: 'cta',
      height: '100vh',
      width: '95vw',
      value: 'cta',
      name: 'Call to Action',
      selected: false,
    },
    {
      typeOf: 'text',
      height: '95vh',
      width: '90vw',
      value: 'text',
      name: 'Text Block',
      selected: false,
    },
    {
      typeOf: 'image',
      height: '95vh',
      width: '90vw',
      value: 'image',
      name: 'Image Block',
      selected: false,
    },
  ];

  Components = [
    {
      typeOf: 'cta',
      height: '100vh',
      width: '95vw',
      value: 'cta',
      name: 'Call to Action',
      selected: false,
    },
    {
      typeOf: 'image',
      height: '95vh',
      width: '90vw',
      value: 'image',
      name: 'Image Block',
      selected: false,
    },
    {
      typeOf: 'text',
      height: '95vh',
      width: '90vw',
      value: 'text',
      name: 'Text Block',
      selected: false,
    },
    {
      typeOf: 'topic',
      height: '85vh',
      width: '90vw',
      value: 'topic',
      name: 'Topic Search',
      selected: false,
    },
  ];

  constructor(
    public dialog: MatDialog,
    private _layoutService: LayoutService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    // swap the component json with footer json if its footer
    if (changes) {
      if (changes.index) {
        this.index = changes.index.currentValue;
      }
      if (changes.footer) {
        this.footer = changes.footer.currentValue;
        if (this.footer == 'true') {
          this.Components = this.Footer;
        }
      }
    }
  }

  openSideNav(typeOf, compArray, template, row, edit) {
    if (typeOf != 0) {
      // do nothing on first value.
      // Make sure the values come in right, and that they align what we need.
      const data = {
        typeOf: typeOf,
        rowType: row,
        rowArray: this.index,
        compArray: compArray,
        template: template,
        edit: edit,
      };
      this._openSideNav(data);
    }
  }

  private _openSideNav(data) {
    this._layoutService.openSideNav({
      template: 'comp',
      position: 'start',
      data: data,
      mode: 'side',
    });
  }
}
